// SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

interface SelectableNode {
  selected: boolean;
  indeterminate: boolean;
  nodes: { selected: boolean; indeterminate: boolean }[];
}

export function updateNodeSelection(node: SelectableNode) {
  const nodes = node.nodes;

  if (nodes.length) {
    if (nodes.every(n => n.selected)) {
      node.selected = true;
      node.indeterminate = false;
    } else if (nodes.some(n => n.selected)) {
      node.indeterminate = true;
    } else if (nodes.every(n => !n.selected)) {
      node.selected = false;
      node.indeterminate = false;
    }
  }

  nodes.forEach(n => updateNodeSelection(n as SelectableNode));
}
